import { Box, keyframes } from '@mui/material';
import TooltipComponent from '../TooltipComponent';

interface IsOnlineComponentProps {
  isOnline: boolean;
  width: number;
  height: number;
  action?: () => void;
  customTooltip?: string;
}

const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const IsOnlineComponent: React.FC<IsOnlineComponentProps> = ({
  isOnline,
  width,
  height,
  action,
  customTooltip,
  ...Props
}) => {
  return (
    <TooltipComponent
      title={customTooltip ?? (isOnline ? 'Online' : 'Offline')}
      placement="left-end"
    >
      <Box
        {...Props}
        sx={{
          width,
          height,
          borderRadius: '50%',
          backgroundColor: isOnline ? '#00C800' : '#B42828',
          display: 'flex',
          animation: isOnline ? `${blink} 1s infinite` : 'none',
          alignItems: 'center',
        }}
        onClick={action}
      />
    </TooltipComponent>
  );
};

export default IsOnlineComponent;
